
export const testPlanningColumns = [
    {
        display_name: "",
        key: "select",
        headerStyles: {
            background: "#7593F2",
            color:"#ffffff",
            padding: "4px 8px",
            width: "50px"
          },
        cellStyles: {
            width: "50px"
          },
        _config: {
          type: "checkbox",
          displayInColumn: true,
          value: "id",
          isClickable: "true"
        }
      },
    {
      key: "plan_no",
      display_name: "Plan No",
      headerStyles: {
        color:"#ffffff",
        
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      key: "plan_name",
      display_name: "Plan Name",
      headerStyles: {
        color:"#ffffff",
        
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      key: "count",
      display_name: "Number Of Test Cases",
      headerStyles: {
        color:"#ffffff",
        
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      key: "date",
      display_name: "Last Execution",
      headerStyles: {
        color:"#ffffff",
        
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
        display_name: "",
        key: "edit",
        headerStyles: {
          background: "#7593F2",
          color:"#ffffff",
          padding: "4px 8px",
          width: "50px",
        },
        _config: {
          type: "svg",
          value: "../../../../assets/images/table/table-item-edit.svg",
          isClickable: "true",
          displayInColumn: false
        },
      },
  ];
